export default __webpack_public_path__ + "static/media/logo.1ee359c9.png";